import type { ChatMessage } from "../../types";
import { fmtTime } from "../../format";
import { Bubble, SystemRow } from "../Bubble";
import { NegativeReplyAction } from "../NegativeReplyAction";
import type { NegativeReplyActionProps } from "../NegativeReplyAction";

export function ConversaTab({ messages, negativeReply }: { messages?: ChatMessage[]; negativeReply: Omit<NegativeReplyActionProps, "placement"> }) {
  return (
    <>
      <div class="thread">
        {!Array.isArray(messages) || messages.length === 0 ? (
          <div class="state-msg">Sem mensagens.</div>
        ) : messages.map((m, i) => {
          const isSystem = m.is_system || m.role === "system";
          const ts = fmtTime(m.created_at);
          if (isSystem) {
            const content = String(m.content || "").replace(/^\[|\]$/g, "");
            return <SystemRow key={i} content={content} ts={ts} />;
          }
          return <Bubble key={i} role={m.role} content={m.content} ts={ts} />;
        })}
      </div>
      <NegativeReplyAction {...negativeReply} placement="conversation" />
    </>
  );
}
